import { isNonEmptyString } from '@/utils/checks'
import removeEmptyKeysAndValues from '@/utils/removeEmptyKeysAndValues'

const shouldUseLocation = (state): boolean => {
  const reducedRefinementList = removeEmptyKeysAndValues(state.refinementList)

  if (
    Object.values(reducedRefinementList).length > 0 &&
    Object.values(reducedRefinementList).every(isNonEmptyString)
  ) {
    return true
  }
  if (
    isNonEmptyString(state?.refinementList?.locations) &&
    isNonEmptyString(state?.locationName)
  ) {
    return true
  }
  return false
}

export default shouldUseLocation
